module.exports = __webpack_public_path__ + "static/img/logo.7f5efa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo.png
// module id = Pl8J
// module chunks = 7